import { CloneOkrsComponent, CloneOkrsModal } from "./components/clone-okrs/clone-okrs.component";
import { CloneOkrsService } from "./components/clone-okrs/clone-okrs.service";

const mod = angular.module("okrs", []);

mod.component("cloneOkrs", CloneOkrsComponent);
mod.service("CloneOkrsModal", CloneOkrsModal);
mod.service("CloneOkrsService", CloneOkrsService);

export default mod.name;
